/* eslint-disable @typescript-eslint/naming-convention */
export interface AbsorbEnrollmentDto {
  CourseId: string;
  CourseName: string;
  CourseURL: string;
  Progress: number;
  Score: number | null;
  DateCompleted: Date | null;
  DateExpires: Date | null;
  CategoryId: string | null;
  CategoryName: string | null;
}
